import apolloClient from './apolloClient';

const customMutation = async (mutation, variables) => {
  const result = await apolloClient.mutate({ mutation, variables });
  return result;
};

export default customMutation;
